export const EMAIL_SUPPORT = 'slash@altermaind.com';
